import { FC } from 'react';

const GreenDot: FC = () => {
  return (
    <>
      <div style={{ background: '#76CC57', height: 8, width: 8, borderRadius: '50%' }}></div>
    </>
  );
};

export default GreenDot;
